/** One identity per page lifetime. Full navigation discards private in-memory state. */
import type { Viewer } from "./core/workspace";
import type { Copy } from "../../server/copy";
let identity: Viewer | null = null;
let language: Copy | null = null;
export function initialise(viewer: Viewer | null, copy: Copy): void { identity = viewer; language = copy; }
export function viewer(): Viewer { if (!identity) throw new Error("No authenticated account"); return identity; }
export function setViewer(value: Viewer): void { identity = value; }
export function copy(): Copy { if (!language) throw new Error("Product copy not loaded"); return language; }
